import { render, staticRenderFns } from "./BowMedia.vue?vue&type=template&id=67ba1770&"
import script from "./BowMedia.vue?vue&type=script&lang=js&"
export * from "./BowMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowRing: require('/workspace/components/atoms/BowRing/BowRing.vue').default,BowHeading: require('/workspace/components/atoms/BowHeading/BowHeading.vue').default,BowImage: require('/workspace/components/atoms/BowImage/BowImage.vue').default,BowSlide: require('/workspace/components/molecules/BowSlider/BowSlide.vue').default,BowSlider: require('/workspace/components/molecules/BowSlider/BowSlider.vue').default,BowText: require('/workspace/components/atoms/BowText/BowText.vue').default,BowCallToAction: require('/workspace/components/molecules/BowCallToAction/BowCallToAction.vue').default})
